var keyMirror = require('keymirror');

module.exports = keyMirror({
	INSIGHTS_BAR: null,
	PHOTO_VIEWS_CSV: null,
	INSIGHTS_BAR_CUSTOMER: null,
	PHOTO_VIEWS_CUSTOMER_CSV: null
});